import * as _ from 'lodash';
import * as moment from 'moment';
import { Alert, Button, ButtonGroup, Col, ControlLabel, Form, FormControl, FormGroup, Row, Well } from 'react-bootstrap';
import { ICenterBase } from '@nkr/models/index';
import usePrevious from '@nkr/services/use-previous';
import { useEffect, useState } from 'react';
import { FormWrapper } from './styles';

interface IProps {
    isAdmin: boolean,
    isLiverCenterView: boolean,
    centerId: number,
    donationYear: string,
    centerType: string,
    minReferrals: string,
    includeDash: boolean,
    includeNkr: boolean,
    isMicrosite: number,
    donationYearList: string[],
    centerList: ICenterBase[],
    onFilter: (donationYear: string, minReferrals: string, includeNkr: boolean, includeDash: boolean, centerType: string, isMicrosite: number) => void
    onExport: () => void
}

const ComparisonConversionFilter = (props: IProps) => {
    const [includeDash, setIncludeDash] = useState(false);
    const [includeNkr, setIncludeNkr] = useState(true);
    const [donationYear, setdonationYear] = useState(moment().format('YYYY'));
    const [isMicrosite, setisMicrosite] = useState(-1);
    const [centerType, setcenterType] = useState('');
    const [minReferrals, setminReferrals] = useState('0');

    const previousProps = usePrevious(props);

    useEffect(() => {
        if (_.isEqual(previousProps, props) == false) {
            setIncludeDash(props.includeDash);
            setIncludeNkr(props.includeNkr);
            setdonationYear(props.donationYear);
            setisMicrosite(props.isMicrosite);
            setcenterType(props.centerType);
            setminReferrals(props.minReferrals);
        }
    }, [props]);

    const handleDonationYearChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        setdonationYear(e.currentTarget.value);
    };

    const handleCenterTypeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        setcenterType(e.currentTarget.value);
    };

    const handleMinReferralsChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        setminReferrals(e.currentTarget.value);
    };

    const handleIncludeChange = (e: React.FormEvent<HTMLButtonElement>) => {
        if (e.currentTarget.value == 'includeDash') {
            setIncludeDash(!includeDash);
        }

        if (e.currentTarget.value == 'includeNkr') {
            setIncludeNkr(!includeNkr);
        }
    };

    const handleMicrositeChange = (e: React.FormEvent<HTMLButtonElement>) => {
        setisMicrosite(parseInt(e.currentTarget.value));
    };

    const handleFilter = () => {
        props.onFilter(donationYear, minReferrals, includeNkr, includeDash, centerType, isMicrosite);
    };

    const handleExport = () => {
        props.onExport();
    };


    const url = "center/" + props.centerId + "/donors/donor-intake/search?"
        + (props.includeDash ? "dash=1" : "dash=0")
        + (props.includeNkr ? "&nkr=1&dcn=1" : "&nkr=0&dcn=0")
        + "&completeStatus=1"
        + "&filterStartDate=" + encodeURI("01/01/" + props.donationYear)
        + "&filterEndDate=" + encodeURI("12/31/" + props.donationYear)
        + "&isInEmr=0&showFilter=0&centerId=" + props.centerId
        + "&sadv=1"



    return (
        <>
            <Well bsSize='sm' style={{ marginBottom: 5 }}>
                <FormWrapper horizontal>
                    <Row>
                        <Col xs={12} lg={4}>
                            <FormGroup>
                                <Col xs={3} componentClass={ControlLabel}>&nbsp;</Col>
                                <Col xs={9}>
                                    <ButtonGroup>
                                        <button type='button' className={"btn " + (includeDash ? 'btn-primary active' : 'btn-default')} value='includeDash' onClick={handleIncludeChange}>DASH</button>
                                        <button type='button' className={"btn " + (includeNkr ? 'btn-primary active' : 'btn-default')} value='includeNkr' onClick={handleIncludeChange}>{props.isLiverCenterView ? 'NLR' : 'NKR'}</button>
                                    </ButtonGroup>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={4}>
                            <FormGroup>
                                <Col xs={4} componentClass={ControlLabel}>Donation Year:&nbsp;</Col>
                                <Col xs={8}>
                                    <FormControl
                                        componentClass='select'
                                        value={donationYear}
                                        onChange={handleDonationYearChange}
                                        style={{ width: '70%' }}
                                    >
                                        {props.donationYearList.map((item, index) =>
                                            <option key={'dy-' + index} value={item}>{item}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={4}>
                            <FormGroup>
                                <Col xs={4} componentClass={ControlLabel}>&nbsp;</Col>
                                <Col xs={8}>
                                    <ButtonGroup>
                                        <button type='button' className={"btn " + (isMicrosite == -1 ? 'btn-primary active' : 'btn-default')} value='-1' onClick={handleMicrositeChange}>ALL</button>
                                        <button type='button' className={"btn " + (isMicrosite == 1 ? 'btn-primary active' : 'btn-default')} value='1' onClick={handleMicrositeChange}>MS</button>
                                        <button type='button' className={"btn " + (isMicrosite == 0 ? 'btn-primary active' : 'btn-default')} value='0' onClick={handleMicrositeChange}>NO MS</button>
                                    </ButtonGroup>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={4}>
                            <FormGroup style={{ marginBottom: 0 }}>
                                <Col xs={3} componentClass={ControlLabel}>Centers:</Col>
                                <Col xs={9}>
                                    <FormControl
                                        componentClass='select'
                                        value={centerType}
                                        onChange={handleCenterTypeChange}
                                        style={{ width: '70%' }}
                                    >
                                        <option value=''>All</option>
                                        {!props.isLiverCenterView && <option value='dcn'>Donor Care Network</option>}
                                        {!props.isLiverCenterView && <option value='voucher'>Voucher Program</option>}
                                        <option value='dsd'>Donor Shield Direct</option>
                                        <option value='fu'>Follow-Up Enabled</option>
                                        <option value='pl'>PL DASH Center</option>
                                        <option value='ms'>Microsite Center</option>
                                        <option value='mscoe'>Microsite Center Of Excellence</option>
                                        <option value='ref'>{props.isLiverCenterView ? 'NLR Referral Network' : 'NKR Referral Network'}</option>
                                        <option value='dc'> Donor Mentor Enabled</option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={4}>
                            <FormGroup style={{ marginBottom: 0 }}>
                                <Col xs={4} componentClass={ControlLabel}>Min Referrals:</Col>
                                <Col xs={8}>
                                    <FormControl
                                        value={minReferrals}
                                        onChange={handleMinReferralsChange}
                                        style={{ width: '70%' }}
                                    >
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={2}>
                            <Button bsStyle='primary' style={{ width: '100%' }} onClick={handleFilter}>Filter</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button style={{ width: '100%' }} onClick={handleExport}>Excel</Button>
                        </Col>
                    </Row>
                </FormWrapper>
            </Well>

            {props.isAdmin == false && (
                <Alert bsStyle='warning' bsSize='sm'>
                    <p>If your donations for the year are lower than expected, you can use
                        <a href={url}>
                            &nbsp;this page
                        </a>
                        , or you can get a CSV file with all donations for a given date range and <a href={"/center/" + props.centerId + "/donors/reconciliation"}>upload here</a> to go through our reconciliation process.
                    </p>
                </Alert>
            )}
        </>
    );
}

export default ComparisonConversionFilter;


